const c = (r) => {
  let t = 0;
  for (const [, o] of Object.entries(r)) {
    let e = 0;
    o.forEach((n) => {
      n === !0 && e++;
    }), t = t + e;
  }
  return t;
};
export {
  c as countFilters
};
